import LandingPageIntegrations from '@/app/components/LandingPage/LandingPageIntegrations';

import { customers } from './data/customers';

const BusinessCustomers = () => {
  return (
    <section data-cy="business-customers" className="py-20">
      <LandingPageIntegrations
        integrations={customers}
        className="justify-center"
        logoColor="black"
      />
    </section>
  );
};

export default BusinessCustomers;
